import http from './http';

export function searchVips(websiteId, page = 1, search = '') {
  const params = new URLSearchParams();
  params.set('page_nbr', page);
  if (search && search.length > 0) {
    params.set('search', search);
  }
  const path = `/website/${websiteId}/vip/search?${params.toString()}`;
  return http.get(path);
}

export function deleteVip(websiteId, vipId) {
  return http.del(`/website/${websiteId}/vip/${vipId}`);
}

export function addVip(websiteId, payload) {
  return http.post(`/website/${websiteId}/vip/add_email`, payload);
}

export default { searchVips, deleteVip, addVip };
